export type BrandingSectionId = 'creatives' | 'emails' | 'buttons';

export interface BrandingSectionDef {
  id: BrandingSectionId;
  label: string;
  description: string;
}

export const BRANDING_SECTION_REGISTRY: readonly BrandingSectionDef[] = [
  {
    id: 'creatives',
    label: 'Creatives',
    description: 'Internal brand asset library — logos, icons, and videos for SHOUT products.',
  },
  {
    id: 'emails',
    label: 'Emails',
    description: 'Transactional emails SHOUT sends, with live HTML previews.',
  },
  {
    id: 'buttons',
    label: 'Buttons',
    description: 'Every shared button class used in the app, with the classes that build it.',
  },
] as const;

export const DEFAULT_BRANDING_SECTION_ID: BrandingSectionId = 'creatives';

/** URL segment under `/admin-options/branding/` for each section. */
export const BRANDING_SECTION_ROUTE_SEGMENTS: Record<BrandingSectionId, string> = {
  creatives: 'creatives',
  emails: 'emails',
  buttons: 'buttons',
};

export function getBrandingSectionPath(sectionId: BrandingSectionId): string {
  return `/admin-options/branding/${BRANDING_SECTION_ROUTE_SEGMENTS[sectionId]}`;
}

export function isBrandingSectionRouteActive(sectionId: BrandingSectionId, url: string): boolean {
  const path = getBrandingSectionPath(sectionId);
  return url === path || url.startsWith(`${path}/`);
}

export function getBrandingSectionById(id: BrandingSectionId): BrandingSectionDef | undefined {
  return BRANDING_SECTION_REGISTRY.find((section) => section.id === id);
}

export function getActiveBrandingSectionId(url: string): BrandingSectionId | null {
  for (const section of BRANDING_SECTION_REGISTRY) {
    if (isBrandingSectionRouteActive(section.id, url)) {
      return section.id;
    }
  }
  return null;
}

export function getActiveBrandingSection(url: string): BrandingSectionDef | undefined {
  const id = getActiveBrandingSectionId(url);
  return id ? getBrandingSectionById(id) : undefined;
}
